"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ActionButton_1 = require("../ActionButton/ActionButton");
/**
 * {@docCategory Button}
 */


exports.CommandButton = ActionButton_1.ActionButton;